import { useQuery } from 'react-query';
import { getDrugById } from 'src/services/api/catalogs';

function useGetDrugCatalog(drugId, params, enabled = false) {
  return useQuery(['drugCatalog', drugId, params], (key, drugId, params) => getDrugById(drugId, params), { enabled });
}

export default useGetDrugCatalog;
